import { MutationTree } from "vuex";
import { SportEvent } from "../../models/sport-events.model";
import { PaginationResponse } from "./../../models/pagination.model";
import { SportEventsState } from "./index";

export const SportEventsMutationTypes = {
  SetSportEvents: "SET_SPORT_EVENTS"
};

export const mutations: MutationTree<SportEventsState> = {
  [SportEventsMutationTypes.SetSportEvents](state: SportEventsState, payload: PaginationResponse<SportEvent[]>) {
    state.sportEvents = payload.data;
    state.paginationMeta = payload.meta;
  }
};
